import { AsyncPipe } from '@angular/common';
import { Component, HostBinding } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { PageMessageBoxComponent } from '@mri-platform/shared/core-ui';
import { AuthService } from '@mri/angular-wfe-proxy-oidc';
import { combineLatest, map, startWith } from 'rxjs';

@Component({
  template: `
    <mri-shared-page-message-box>
      <span class="header-text"> You do not have the necessary permissions to access the {{ appName }} Site </span>
      @let clientId = currentClientId$ | async;
      @let hasAlternative = hasAlternativeClientId$ | async;
      @if (authService.config.manageClientIdSelection) {
        <p class="body-text mri-color-gray-80">
          @if (clientId) {
            Your current client ID: <strong>{{ clientId }}</strong>
            @if (hasAlternative) {
              <a
                [routerLink]="['../', this.authService.config.clientSelectionRoute]"
                [queryParams]="clientSelectionQueryParams(clientId)"
                class="mri-link"
              >
                - Try another?</a
              >
            }
          } @else {
            Client Id not set
            @if (hasAlternative) {
              <a [routerLink]="['../', this.authService.config.clientSelectionRoute]" class="mri-link">
                - Select your client id</a
              >
            }
          }
        </p>
      }
    </mri-shared-page-message-box>
  `,
  styles: [
    `
      :host {
        height: 100%;
        background: no-repeat url('/assets/unauthorized-page/background.png');
        background-size: cover;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        height: 100%;
      }
    `
  ],
  imports: [PageMessageBoxComponent, RouterLink, AsyncPipe],
  standalone: true
})
export class UnauthorizedPageComponent {
  @HostBinding('attr.data-testid') testId = 'UnauthorizedPageComponent';
  appName = '';
  currentClientId$ = this.authService.currentClientId$;
  hasAlternativeClientId$ = this.createHasAlternativeClientId$(this.authService);

  constructor(
    titleService: Title,
    protected authService: AuthService
  ) {
    this.appName = titleService.getTitle();
  }

  clientSelectionQueryParams(clientId: string) {
    return { [this.authService.config.mriClientIdQueryParamName]: clientId };
  }

  private createHasAlternativeClientId$(authService: AuthService) {
    return combineLatest([
      authService.userLoaded$.pipe(map(user => authService.getAvailableClientIds(user))),
      authService.currentClientId$
    ]).pipe(
      map(([ids, currentId]) => ids.some(id => id !== currentId)),
      startWith(true)
    );
  }
}
